import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
@Component({
  templateUrl: "./error.component.html",
  styleUrls: ["error.css"]
})
export class ErrorComponent {
  environment: any;
  errorMessage: string;


  constructor(private route:ActivatedRoute) {
    this.environment = environment
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.errorMessage = params['errorMessage'];
    })
  }
}
